import React, { useEffect, useRef, useState } from "react";
import {
  AlertCircle,
  Upload,
  X,
  Save,
  CheckCircle,
  Plus,
  Trash2,
} from "lucide-react";
import "./CreateProduct.css";
import MasterLayout from "../../masterLayout/MasterLayout";
import { BASE_URL, getProductCategoriesApi, IMG_URL } from "../../helper/api_helper";
import toast from "react-hot-toast";
import ReactQuill, { Quill } from "react-quill-new";
import hljs from "highlight.js";
import { useSearchParams } from "react-router-dom";

const CreateProduct = () => {
  const [activeTab, setActiveTab] = useState("basic");
  const [searchParams] = useSearchParams();
  const productId = searchParams.get("id");
  const isEditMode = Boolean(productId);
  const [formData, setFormData] = useState({
    productName: "",
    productCategory: "",
    productDescription: "",
    medicineName: "",
    genericName: "",
    dosageForm: "",
    manufacturer: "",
    medicalTitle: "",
    medicalDescription: "",
    primaryUse: "",
    clinicalOverview: "",
    warnings: "",
    documentation: "",
    sourcing: "",
    faqs: [{ title: "", description: "" }],
    altTag: "",
    metaDescription: "",
    metaTitle: "",
    slug: "",
  });
  console.log("FORM DATA :::", formData);

  const [images, setImages] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [completedTabs, setCompletedTabs] = useState([]);
  const [productCategorys, setProductCategorys] = useState([]);
  console.log("PRODUCT CATEGORIES ::", productCategorys);

  const getProductCategory = async () => {
    try {
      let response = await getProductCategoriesApi();
      if (response.status) {
        setProductCategorys(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProductCategory();
  }, []);
  const [isHighlightReady, setIsHighlightReady] = useState(false);
  const quillRef = useRef(null);
  const warningRef = useRef(null);
  const sourcingRef = useRef(null);
  const documentationRef = useRef(null);



  const linkHandler = () => {
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection();

    if (range) {
      if (range.length > 0) {
        const href = prompt('Enter the link URL:\n(Examples: / or /services or https://example.com)', '/');
        if (href) {
          quill.formatText(range.index, range.length, 'link', href);
        }
      } else {
        const linkText = prompt('Enter the text to display:', '');
        if (linkText) {
          const href = prompt('Enter the link URL:\n(Examples: / or /services or https://example.com)', '/');
          if (href) {
            quill.insertText(range.index, linkText, 'link', href);
            quill.setSelection(range.index + linkText.length);
          }
        }
      }
    }
  };

  // toolbar-warnings
  const modules = isHighlightReady
    ? {
      syntax: {
        highlight: (text) => hljs?.highlightAuto(text).value,
      },
      toolbar: {
        container: "#toolbar-container",
        handlers: {
          link: linkHandler
        }
      },
    }
    : {
      toolbar: {
        container: "#toolbar-container",
      },
    };


  const modulesWarnings = isHighlightReady
    ? {
      syntax: {
        highlight: (text) => hljs?.highlightAuto(text).value,
      },
      toolbar: {
        container: "#toolbar-warnings",
        handlers: {
          link: linkHandler
        }
      },
    }
    : {
      toolbar: {
        container: "#toolbar-warnings",
      },
    };



  const modulesDocumentation = isHighlightReady
    ? {
      syntax: {
        highlight: (text) => hljs?.highlightAuto(text).value,
      },
      toolbar: {
        container: "#toolbar-documentation",
        handlers: {
          link: linkHandler
        }
      },
    }
    : {
      toolbar: {
        container: "#toolbar-documentation",
      },
    };


  const modulesSourcing = isHighlightReady
    ? {
      syntax: {
        highlight: (text) => hljs?.highlightAuto(text).value,
      },
      toolbar: {
        container: "#toolbar-sourcing",
        handlers: {
          link: linkHandler
        }
      },
    }
    : {
      toolbar: {
        container: "#toolbar-sourcing",
      },
    };


  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "header",
    "blockquote",
    "code-block",
    "list",
    "indent",
    "direction",
    "align",
    "link",
    "image",
    "video",
    "formula",
  ];

  useEffect(() => {
    hljs?.configure({
      languages: [
        "javascript",
        "ruby",
        "python",
        "java",
        "csharp",
        "cpp",
        "go",
        "php",
        "swift",
      ],
    });
  }, []);
  const tabs = [
    { id: "basic", label: "Basic Information", required: true },
    { id: "medical", label: "Medical Uses", required: false },
    { id: "warning", label: "Warning & Precaution", required: false },
    {
      id: "documentation",
      label: "Documentation & Availability",
      required: false,
    },
    { id: "sourcing", label: "Sourcing & Delivery", required: false },
    { id: "faq", label: "FAQ", required: false },
    { id: "seo", label: "SEO", required: false },
  ];

  const validateBasicInfo = () => {
    const newErrors = {};

    if (!formData.productName.trim()) {
      newErrors.productName = "Product name is required";
    }

    if (!formData.productCategory) {
      newErrors.productCategory = "Product category is required";
    }

    // if (!formData.productDescription.trim()) {
    //   newErrors.productDescription = "Product description is required";
    // }

    if (!formData.medicineName.trim()) {
      newErrors.medicineName = "Medicine name is required";
    }

    if (!formData.genericName.trim()) {
      newErrors.genericName = "Generic name is required";
    }

    if (!formData.dosageForm.trim()) {
      newErrors.dosageForm = "Dosage form is required";
    }

    if (!formData.manufacturer.trim()) {
      newErrors.manufacturer = "Manufacturer is required";
    }

    if (images.length === 0) {
      newErrors.images = "At least one product image is required";
    }

    return newErrors;
  };
  useEffect(() => {
    if (isEditMode) {
      loadProductForEditing();
    }
  }, [productId]);
  const loadProductForEditing = async () => {
    try {
      const res = await fetch(`${BASE_URL}/products/get-all-products`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ categoryId: "" }) // empty = fetch all
      });

      const result = await res.json();

      if (!result.status) {
        toast.error("Failed to load products");
        return;
      }

      const allProducts = result.data || [];

      // Find the product using productId from query params
      const product = allProducts.find(p => p.id == productId);

      if (!product) {
        toast.error("Product not found!");
        return;
      }

      // Fill formData
      setFormData({
        productName: product.productName || "",
        productCategory: product.productCategory || "",
        productDescription: product.productDescription || "",
        medicineName: product.medicineName || "",
        genericName: product.genericName || "",
        dosageForm: product.dosageForm || "",
        manufacturer: product.manufacturer || "",
        medicalTitle: product.medicalTitle || "",
        medicalDescription: product.medicalDescription || "",
        primaryUse: product.primaryUse || "",
        clinicalOverview: product.clinicalOverview || "",
        warnings: product.warnings || "",
        documentation: product.documentation || "",
        sourcing: product.sourcing || "",
        faqs: product.faqs?.length ? product.faqs : [{ title: "", description: "" }],
        altTag: product.altTag || "",
        metaDescription: product.metaDescription || "",
        metaTitle: product.metaTitle || "",
        slug: product.slug || "",
      });

      // Pre-fill images (existing URLs)
      if (product.productImages) {
        setImages(
          product.productImages.map((filename) => ({
            preview: `${IMG_URL}/${filename}`,   // Add IMG_URL prefix
            file: null,
            existing: true,
            id: crypto.randomUUID(),
          }))
        );
      }


    } catch (err) {
      console.error(err);
      toast.error("Error loading product");
    }
  };


  // const validateSEO = () => {
  //   const newErrors = {};

  //   if (!formData.slug.trim()) {
  //     newErrors.slug = "Slug is required";
  //   }

  //   if (!formData.metaTitle.trim()) {
  //     newErrors.metaTitle = "Meta title is required";
  //   }

  //   if (!formData.metaDescription.trim()) {
  //     newErrors.metaDescription = "Meta description is required";
  //   }

  //   if (!formData.altTag.trim()) {
  //     newErrors.altTag = "Alt tag is required";
  //   }

  //   return newErrors;
  // };

  const validateFAQ = () => {
    const newErrors = {};

    formData.faqs.forEach((faq, index) => {
      if (faq.title.trim() && !faq.description.trim()) {
        newErrors[`faq_${index}_description`] =
          "Description is required when title is provided";
      }
    });

    return newErrors;
  };

  const validateCurrentTab = () => {
    let newErrors = {};

    if (activeTab === "basic") {
      newErrors = validateBasicInfo();
    } else if (activeTab === "faq") {
      newErrors = validateFAQ();
    } else if (activeTab === "seo") {
      // newErrors = validateSEO();
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };


  const handleQuillChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Remove error if exists
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };




  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      id: Math.random().toString(36),
    }));
    setImages((prev) => [...prev, ...newImages]);
    if (errors.images) {
      setErrors((prev) => ({ ...prev, images: "" }));
    }
  };

  const removeImage = (id) => {
    setImages((prev) => prev.filter((img) => img.id !== id));
  };

  const handleFAQChange = (index, field, value) => {
    const newFaqs = [...formData.faqs];
    newFaqs[index][field] = value;
    setFormData((prev) => ({ ...prev, faqs: newFaqs }));
    if (errors[`faq_${index}_${field}`]) {
      setErrors((prev) => ({ ...prev, [`faq_${index}_${field}`]: "" }));
    }
  };

  const addFAQ = () => {
    setFormData((prev) => ({
      ...prev,
      faqs: [...prev.faqs, { title: "", description: "" }],
    }));
  };

  const removeFAQ = (index) => {
    if (formData.faqs.length > 1) {
      setFormData((prev) => ({
        ...prev,
        faqs: prev.faqs.filter((_, i) => i !== index),
      }));
    }
  };

  const handleTabChange = (tabId) => {
    if (validateCurrentTab()) {
      if (!completedTabs.includes(activeTab)) {
        setCompletedTabs((prev) => [...prev, activeTab]);
      }
      setActiveTab(tabId);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleNext = () => {
    if (validateCurrentTab()) {
      if (!completedTabs.includes(activeTab)) {
        setCompletedTabs((prev) => [...prev, activeTab]);
      }
      const currentIndex = tabs.findIndex((tab) => tab.id === activeTab);
      if (currentIndex < tabs.length - 1) {
        setActiveTab(tabs[currentIndex + 1].id);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  const handlePrevious = () => {
    const currentIndex = tabs.findIndex((tab) => tab.id === activeTab);
    if (currentIndex > 0) {
      setActiveTab(tabs[currentIndex - 1].id);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate current tab first
    if (activeTab === "faq") {
      const currentFaqErrors = validateFAQ();
      if (Object.keys(currentFaqErrors).length > 0) {
        setErrors(currentFaqErrors);
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
    } else if (activeTab === "seo") {
      // const currentSeoErrors = validateSEO();
      // if (Object.keys(currentSeoErrors).length > 0) {
      //   setErrors(currentSeoErrors);
      //   window.scrollTo({ top: 0, behavior: "smooth" });
      //   return;
      // }
    }

    // Validate all required fields from both tabs
    const basicErrors = validateBasicInfo();
    // const seoErrors = validateSEO();
    const allFaqErrors = validateFAQ();
    const allErrors = { ...basicErrors, ...allFaqErrors };

    if (Object.keys(allErrors).length > 0) {
      setErrors(allErrors);

      // Navigate to the first tab with errors
      if (Object.keys(basicErrors).length > 0) {
        setActiveTab("basic");
        toast.error("Please fill all required fields in Basic Information tab");
      }

      // else if (Object.keys(seoErrors).length > 0) {
      //   setActiveTab("seo");
      //   toast.error("Please fill all required fields in SEO tab");
      // }

      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    setIsSubmitting(true);

    try {
      const submitData = new FormData();

      // Append all form fields
      Object.keys(formData).forEach((key) => {
        if (key === "faqs") {
          // Filter out empty FAQs before submission
          const validFaqs = formData[key].filter(
            (faq) => faq.title.trim() !== "" || faq.description.trim() !== ""
          );
          submitData.append(key, JSON.stringify(validFaqs));
        } else {
          submitData.append(key, formData[key]);
        }
      });

      // Append images
      images.forEach((img) => {
        submitData.append(`productImages`, img.file);
      });

      const response = await fetch(`${BASE_URL}/products/create-Product`, {
        method: "POST",
        body: submitData,
      });

      if (!response.ok) {
        throw new Error("Failed to create product or image is large");
      }

      const result = await response.json();

      if (result.status) {
        toast.success(result.message);

        // Reset form
        setFormData({
          productName: "",
          productCategory: "",
          productDescription: "",
          medicineName: "",
          genericName: "",
          dosageForm: "",
          manufacturer: "",
          medicalTitle: "",
          medicalDescription: "",
          primaryUse: "",
          clinicalOverview: "",
          warnings: "",
          documentation: "",
          sourcing: "",
          faqs: [{ title: "", description: "" }],
          altTag: "",
          metaDescription: "",
          metaTitle: "",
          slug: "",
        });

        setImages([]);
        setErrors({});
        setCompletedTabs([]);
        setActiveTab("basic");
      } else {
        toast.error(result.message || "Failed to create product");
      }
    } catch (error) {
      console.error("Error creating product:", error);
      toast.error("Failed to create product. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderBasicInfo = () => (
    <div className="tab-content">
      <div className="form-grid">
        <div className="form-group">
          <label className="form-label form-label-required">Product Name</label>
          <input
            type="text"
            name="productName"
            value={formData.productName}
            onChange={handleInputChange}
            className={`form-input ${errors.productName ? "error" : ""}`}
            placeholder="Enter product name"
          />
          {errors.productName && (
            <p className="form-error">
              <AlertCircle className="icon-sm" />
              {errors.productName}
            </p>
          )}
        </div>

        <div className="form-group">
          <label className="form-label form-label-required">
            Product Category
          </label>
          <select
            name="productCategory"
            value={formData.productCategory}
            onChange={handleInputChange}
            className={`form-input ${errors.productCategory ? "error" : ""}`}
          >
            <option value="">Select Category</option>
            {productCategorys.map((items, index) => {
              return (
                <option key={index} value={items.id}>
                  {items.categoryName}
                </option>
              );
            })}
          </select>

          {errors.productCategory && (
            <p className="form-error">
              <AlertCircle className="icon-sm" />
              {errors.productCategory}
            </p>
          )}
        </div>

        {/* <div className="form-group form-grid-full">
          <label className="form-label form-label-required">
            Product Description
          </label>
          <textarea
            name="productDescription"
            value={formData.productDescription}
            onChange={handleInputChange}
            rows="4"
            className={`form-textarea ${
              errors.productDescription ? "error" : ""
            }`}
            placeholder="Provide a detailed description of the product..."
          />
          {errors.productDescription && (
            <p className="form-error">
              <AlertCircle className="icon-sm" />
              {errors.productDescription}
            </p>
          )}
        </div> */}

        <div className="form-group">
          <label className="form-label form-label-required">
            Medicine Name
          </label>
          <input
            type="text"
            name="medicineName"
            value={formData.medicineName}
            onChange={handleInputChange}
            className={`form-input ${errors.medicineName ? "error" : ""}`}
            placeholder="e.g., NEXTSTELLIS"
          />
          {errors.medicineName && (
            <p className="form-error">
              <AlertCircle className="icon-sm" />
              {errors.medicineName}
            </p>
          )}
        </div>

        <div className="form-group">
          <label className="form-label form-label-required">Generic Name</label>
          <input
            type="text"
            name="genericName"
            value={formData.genericName}
            onChange={handleInputChange}
            className={`form-input ${errors.genericName ? "error" : ""}`}
            placeholder="e.g., Drospirenone and Estetrol"
          />
          {errors.genericName && (
            <p className="form-error">
              <AlertCircle className="icon-sm" />
              {errors.genericName}
            </p>
          )}
        </div>

        <div className="form-group">
          <label className="form-label form-label-required">
            Dosage Form & Strength
          </label>
          <input
            type="text"
            name="dosageForm"
            value={formData.dosageForm}
            onChange={handleInputChange}
            className={`form-input ${errors.dosageForm ? "error" : ""}`}
            placeholder="e.g., 28 Tablets: 3 mg / 14.2 mg"
          />
          {errors.dosageForm && (
            <p className="form-error">
              <AlertCircle className="icon-sm" />
              {errors.dosageForm}
            </p>
          )}
        </div>

        <div className="form-group">
          <label className="form-label form-label-required">
            Manufactured By
          </label>
          <input
            type="text"
            name="manufacturer"
            value={formData.manufacturer}
            onChange={handleInputChange}
            className={`form-input ${errors.manufacturer ? "error" : ""}`}
            placeholder="e.g., Mayne Pharma US"
          />
          {errors.manufacturer && (
            <p className="form-error">
              <AlertCircle className="icon-sm" />
              {errors.manufacturer}
            </p>
          )}
        </div>

        <div className="form-group form-grid-full">
          <label className="form-label form-label-required">
            Product Images
          </label>
          <div className="upload-area">
            <Upload className="upload-icon" />
            <div className="upload-text">
              <label style={{ cursor: "pointer" }}>
                <span className="upload-text-primary">Upload images</span>{" "}
                <br />
                <span className="upload-text-secondary"> or drag and drop</span>
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={{ display: "none" }}
                />
              </label>
            </div>
            <p className="upload-hint">PNG, JPG, WEBP up to 10MB each</p>
          </div>

          {errors.images && (
            <p className="form-error">
              <AlertCircle className="icon-sm" />
              {errors.images}
            </p>
          )}

          {images.length > 0 && (
            <div className="image-grid">
              {images.map((img) => (
                <div key={img.id} className="image-preview">
                  <img src={img.preview} alt="Product" />
                  <button
                    type="button"
                    onClick={() => removeImage(img.id)}
                    className="image-remove-btn"
                  >
                    <X className="icon-sm" />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderMedicalUses = () => (
    <div className="tab-content">
      <div className="form-grid">
        <div className="form-group form-grid-full">
          <label className="form-label">Title</label>
          <input
            type="text"
            name="medicalTitle"
            value={formData.medicalTitle}
            onChange={handleInputChange}
            className="form-input"
            placeholder="Enter medical uses title"
          />
        </div>

        <div className="form-group form-grid-full">
          <label className="form-label">Description</label>
          {/* <textarea
            name="medicalDescription"
            value={formData.medicalDescription}
            onChange={handleInputChange}
            rows="3"
            className="form-textarea"
            placeholder="Enter description..."
          /> */}

          <div className='border border-neutral-200 radius-8 overflow-hidden'>
            <div className='height-200'>
              <div id='toolbar-container'>
                <span className='ql-formats'>
                  <select className='ql-font'></select>
                  <select className='ql-size'></select>
                </span>
                <span className='ql-formats'>
                  <button className='ql-bold'></button>
                  <button className='ql-italic'></button>
                  <button className='ql-underline'></button>
                  <button className='ql-strike'></button>
                </span>
                <span className='ql-formats'>
                  <select className='ql-color'></select>
                  <select className='ql-background'></select>
                </span>
                <span className='ql-formats'>
                  <button className='ql-script' value='sub'></button>
                  <button className='ql-script' value='super'></button>
                </span>
                <span className='ql-formats'>
                  <button className='ql-header' value='1'></button>
                  <button className='ql-header' value='2'></button>
                  <button className='ql-blockquote'></button>
                  <button className='ql-code-block'></button>
                </span>
                <span className='ql-formats'>
                  <button className='ql-list' value='ordered'></button>
                  <button className='ql-list' value='bullet'></button>
                  <button className='ql-indent' value='-1'></button>
                  <button className='ql-indent' value='+1'></button>
                </span>
                <span className='ql-formats'>
                  <button className='ql-direction' value='rtl'></button>
                  <select className='ql-align'></select>
                </span>
                <span className='ql-formats'>
                  <button className='ql-link'></button>
                  <button className='ql-image'></button>
                  <button className='ql-video'></button>
                  <button className='ql-formula'></button>
                </span>
                <span className='ql-formats'>
                  <button className='ql-clean'></button>
                </span>
              </div>

              <ReactQuill
                ref={quillRef}
                theme='snow'
                value={formData.medicalDescription}
                onChange={(value) => handleQuillChange("medicalDescription", value)}
                modules={modules}
                formats={formats}
                placeholder='Compose an epic...'
              />

            </div>
          </div>
        </div>

        <div className="form-group form-grid-full">
          <label className="form-label">Primary Use</label>
          <div className="rich-text-editor">
            <textarea
              name="primaryUse"
              value={formData.primaryUse}
              onChange={handleInputChange}
              rows="6"
              className="form-textarea"
              placeholder="Enter primary uses (supports rich text)..."
            />
          </div>
          <span className="form-hint">
            Rich text editor - supports formatting
          </span>
        </div>

        <div className="form-group form-grid-full">
          <label className="form-label">Clinical Overview</label>
          <textarea
            name="clinicalOverview"
            value={formData.clinicalOverview}
            onChange={handleInputChange}
            rows="4"
            className="form-textarea"
            placeholder="Enter clinical overview..."
          />
        </div>
      </div>
    </div>
  );

  const renderWarning = () => (
    <div className="tab-content">
      <div className="form-group">
        <label className="form-label">Warnings & Precautions</label>
        {/* <textarea
          name="warnings"
          value={formData.warnings}
          onChange={handleInputChange}
          rows="8"
          className="form-textarea"
          placeholder="Enter warnings and precautions..."
        /> */}
        <div className='border border-neutral-200 radius-8 overflow-hidden'>
          <div className='height-200'>
            <div id='toolbar-warnings'>
              <span className='ql-formats'>
                <select className='ql-font'></select>
                <select className='ql-size'></select>
              </span>
              <span className='ql-formats'>
                <button className='ql-bold'></button>
                <button className='ql-italic'></button>
                <button className='ql-underline'></button>
                <button className='ql-strike'></button>
              </span>
              <span className='ql-formats'>
                <select className='ql-color'></select>
                <select className='ql-background'></select>
              </span>
              <span className='ql-formats'>
                <button className='ql-script' value='sub'></button>
                <button className='ql-script' value='super'></button>
              </span>
              <span className='ql-formats'>
                <button className='ql-header' value='1'></button>
                <button className='ql-header' value='2'></button>
                <button className='ql-blockquote'></button>
                <button className='ql-code-block'></button>
              </span>
              <span className='ql-formats'>
                <button className='ql-list' value='ordered'></button>
                <button className='ql-list' value='bullet'></button>
                <button className='ql-indent' value='-1'></button>
                <button className='ql-indent' value='+1'></button>
              </span>
              <span className='ql-formats'>
                <button className='ql-direction' value='rtl'></button>
                <select className='ql-align'></select>
              </span>
              <span className='ql-formats'>
                <button className='ql-link'></button>
                <button className='ql-image'></button>
                <button className='ql-video'></button>
                <button className='ql-formula'></button>
              </span>
              <span className='ql-formats'>
                <button className='ql-clean'></button>
              </span>
            </div>

            <ReactQuill
              key="warnings-editor"
              ref={warningRef}
              theme='snow'
              value={formData.warnings}
              onChange={(value) => handleQuillChange("warnings", value)}
              modules={modulesWarnings}
              formats={formats}
              placeholder='Compose an epic...'
            />

          </div>
        </div>

      </div>
    </div>
  );

  const renderDocumentation = () => (
    <div className="tab-content">
      <div className="form-group">
        <label className="form-label">Documentation & Availability</label>
        {/* <textarea
          name="documentation"
          value={formData.documentation}
          onChange={handleInputChange}
          rows="8"
          className="form-textarea"
          placeholder="Enter documentation and availability information..."
        /> */}

        <div className='border border-neutral-200 radius-8 overflow-hidden'>
          <div className='height-200'>
            <div id='toolbar-documentation'>
              <span className='ql-formats'>
                <select className='ql-font'></select>
                <select className='ql-size'></select>
              </span>
              <span className='ql-formats'>
                <button className='ql-bold'></button>
                <button className='ql-italic'></button>
                <button className='ql-underline'></button>
                <button className='ql-strike'></button>
              </span>
              <span className='ql-formats'>
                <select className='ql-color'></select>
                <select className='ql-background'></select>
              </span>
              <span className='ql-formats'>
                <button className='ql-script' value='sub'></button>
                <button className='ql-script' value='super'></button>
              </span>
              <span className='ql-formats'>
                <button className='ql-header' value='1'></button>
                <button className='ql-header' value='2'></button>
                <button className='ql-blockquote'></button>
                <button className='ql-code-block'></button>
              </span>
              <span className='ql-formats'>
                <button className='ql-list' value='ordered'></button>
                <button className='ql-list' value='bullet'></button>
                <button className='ql-indent' value='-1'></button>
                <button className='ql-indent' value='+1'></button>
              </span>
              <span className='ql-formats'>
                <button className='ql-direction' value='rtl'></button>
                <select className='ql-align'></select>
              </span>
              <span className='ql-formats'>
                <button className='ql-link'></button>
                <button className='ql-image'></button>
                <button className='ql-video'></button>
                <button className='ql-formula'></button>
              </span>
              <span className='ql-formats'>
                <button className='ql-clean'></button>
              </span>
            </div>

            <ReactQuill
              ref={documentationRef}
              key="documentation-editor"
              theme='snow'
              value={formData.documentation}
              onChange={(value) => handleQuillChange("documentation", value)}
              modules={modulesDocumentation}
              formats={formats}
              placeholder='Compose an epic...'
            />

          </div>
        </div>

      </div>
    </div>
  );

  const renderSourcing = () => (
    <div className="tab-content">
      <div className="form-group">
        <label className="form-label">Sourcing & Delivery</label>
        {/* <div className="rich-text-editor">
          <textarea
            name="sourcing"
            value={formData.sourcing}
            onChange={handleInputChange}
            rows="8"
            className="form-textarea"
            placeholder="Enter sourcing and delivery information (supports rich text)..."
          />
        </div> */}
        {/* <span className="form-hint">
          Rich text editor - supports formatting
        </span> */}

        <div className='border border-neutral-200 radius-8 overflow-hidden'>
          <div className='height-200'>
            <div id='toolbar-sourcing'>
              <span className='ql-formats'>
                <select className='ql-font'></select>
                <select className='ql-size'></select>
              </span>
              <span className='ql-formats'>
                <button className='ql-bold'></button>
                <button className='ql-italic'></button>
                <button className='ql-underline'></button>
                <button className='ql-strike'></button>
              </span>
              <span className='ql-formats'>
                <select className='ql-color'></select>
                <select className='ql-background'></select>
              </span>
              <span className='ql-formats'>
                <button className='ql-script' value='sub'></button>
                <button className='ql-script' value='super'></button>
              </span>
              <span className='ql-formats'>
                <button className='ql-header' value='1'></button>
                <button className='ql-header' value='2'></button>
                <button className='ql-blockquote'></button>
                <button className='ql-code-block'></button>
              </span>
              <span className='ql-formats'>
                <button className='ql-list' value='ordered'></button>
                <button className='ql-list' value='bullet'></button>
                <button className='ql-indent' value='-1'></button>
                <button className='ql-indent' value='+1'></button>
              </span>
              <span className='ql-formats'>
                <button className='ql-direction' value='rtl'></button>
                <select className='ql-align'></select>
              </span>
              <span className='ql-formats'>
                <button className='ql-link'></button>
                <button className='ql-image'></button>
                <button className='ql-video'></button>
                <button className='ql-formula'></button>
              </span>
              <span className='ql-formats'>
                <button className='ql-clean'></button>
              </span>
            </div>

            <ReactQuill
              ref={sourcingRef}
              key="sourcing-editor"
              theme='snow'
              value={formData.sourcing}
              onChange={(value) => handleQuillChange("sourcing", value)}
              modules={modulesSourcing}
              formats={formats}
              placeholder='Compose an epic...'
            />

          </div>
        </div>
      </div>
    </div>
  );

  const renderFAQ = () => (
    <div className="tab-content">
      <div className="section-header-with-button">
        <h3 style={{ margin: 0, fontSize: "1.125rem", fontWeight: 600 }}>
          FAQ Items
        </h3>
        <button
          type="button"
          onClick={addFAQ}
          className="btn btn-primary btn-small"
        >
          <Plus className="icon-sm" />
          Add FAQ
        </button>
      </div>

      <div className="space-y-4">
        {formData.faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div className="faq-item-header">
              <span className="faq-item-number">FAQ #{index + 1}</span>
              {formData.faqs.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeFAQ(index)}
                  className="btn btn-icon-only btn-danger"
                >
                  <Trash2 className="icon-sm" />
                </button>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">Title</label>
              <input
                type="text"
                value={faq.title}
                onChange={(e) =>
                  handleFAQChange(index, "title", e.target.value)
                }
                className="form-input"
                placeholder="Enter FAQ title"
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                Description
                {faq.title.trim() && <span className="text-red-500"> *</span>}
              </label>
              <textarea
                value={faq.description}
                onChange={(e) =>
                  handleFAQChange(index, "description", e.target.value)
                }
                rows="3"
                className={`form-textarea ${errors[`faq_${index}_description`] ? "error" : ""
                  }`}
                placeholder="Enter FAQ description"
              />
              {errors[`faq_${index}_description`] && (
                <p className="form-error">
                  <AlertCircle className="icon-sm" />
                  {errors[`faq_${index}_description`]}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderSEO = () => (
    <div className="tab-content">
      <div className="form-grid">
        <div className="form-group form-grid-full">
          <label className="form-label form-label-required">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleInputChange}
            className={`form-input ${errors.slug ? "error" : ""}`}
            placeholder="Enter product slug"
          />
          {errors.slug && (
            <p className="form-error">
              <AlertCircle className="icon-sm" />
              {errors.slug}
            </p>
          )}
        </div>

        <div className="form-group form-grid-full">
          <label className="form-label form-label-required">Meta Title</label>
          <input
            name="metaTitle"
            value={formData.metaTitle}
            onChange={handleInputChange}
            className={`form-input ${errors.metaTitle ? "error" : ""}`}
            placeholder="Enter meta title"
          />
          {errors.metaTitle && (
            <p className="form-error">
              <AlertCircle className="icon-sm" />
              {errors.metaTitle}
            </p>
          )}
        </div>

        <div className="form-group form-grid-full">
          <label className="form-label form-label-required">Meta Description</label>
          <div className="rich-text-editor">
            <textarea
              name="metaDescription"
              value={formData.metaDescription}
              onChange={handleInputChange}
              className={`form-textarea ${errors.metaDescription ? "error" : ""
                }`}
              placeholder="Enter meta description"
            />
            {errors.metaDescription && (
              <p className="form-error">
                <AlertCircle className="icon-sm" />
                {errors.metaDescription}
              </p>
            )}
          </div>
        </div>

        <div className="form-group form-grid-full">
          <label className="form-label form-label-required">Alt Tag</label>
          <input
            name="altTag"
            value={formData.altTag}
            onChange={handleInputChange}
            className={`form-input ${errors.altTag ? "error" : ""}`}
            placeholder="Enter alt tag"
          />
          {errors.altTag && (
            <p className="form-error">
              <AlertCircle className="icon-sm" />
              {errors.altTag}
            </p>
          )}
        </div>
      </div>
    </div>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case "basic":
        return renderBasicInfo();
      case "medical":
        return renderMedicalUses();
      case "warning":
        return renderWarning();
      case "documentation":
        return renderDocumentation();
      case "sourcing":
        return renderSourcing();
      case "faq":
        return renderFAQ();
      case "seo":
        return renderSEO();
      default:
        return renderBasicInfo();
    }
  };

  return (
    <MasterLayout>
      <div className="create-product-container">
        <div className="create-product-wrapper">
          <div className="product-layout">
            <div className="sidebar-tabs">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => handleTabChange(tab.id)}
                  className={`tab-button ${activeTab === tab.id ? "active" : ""
                    } ${completedTabs.includes(tab.id) ? "completed" : ""}`}
                >
                  <div className="tab-button-content">
                    <span className="tab-label">{tab.label}</span>
                    {tab.required && <span className="tab-required">*</span>}
                  </div>
                  {completedTabs.includes(tab.id) && (
                    <CheckCircle className="tab-check-icon" />
                  )}
                </button>
              ))}
            </div>

            <div className="main-content">
              <div className="product-card">
                <div className="tab-header">
                  <h2 className="tab-title">
                    {tabs.find((tab) => tab.id === activeTab)?.label}
                    {tabs.find((tab) => tab.id === activeTab)?.required && (
                      <span className="text-red-500"> *</span>
                    )}
                  </h2>
                  {!tabs.find((tab) => tab.id === activeTab)?.required && (
                    <span className="tab-optional-badge">Optional</span>
                  )}
                </div>

                {renderTabContent()}

                <div className="tab-navigation">
                  <div className="tab-nav-left">
                    {activeTab !== "basic" && (
                      <button
                        type="button"
                        onClick={handlePrevious}
                        className="btn btn-secondary"
                      >
                        Previous
                      </button>
                    )}
                  </div>
                  <div className="tab-nav-right">
                    {activeTab !== "seo" ? (
                      <button
                        type="button"
                        onClick={handleNext}
                        className="btn btn-primary"
                      >
                        Next
                      </button>
                    ) : (
                      <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        className="btn btn-primary"
                      >
                        {isSubmitting ? (
                          <>
                            <div className="spinner" />
                            Creating...
                          </>
                        ) : (
                          <>
                            <Save className="icon-sm" />
                            Create Product
                          </>
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default CreateProduct;